import React from 'react';
import styled from 'styled-components';

/* Components ---------------------------*/
import Button from './Button.jsx';

const SelectButton = ({ selectedButton, selectedButtonUpdate, tableSelect }) => {

    return (
        <SelectButtonStyled className='SelectButton'>
            {
                tableSelect.map((button, idx) => {
                    return  <Button key={ idx } button={ button } selectedButton={ selectedButton } selectedButtonUpdate={ selectedButtonUpdate } />
                })
            }
        </SelectButtonStyled>
    );
}

export default SelectButton;

const SelectButtonStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: row-reverse;

    .Button {
        margin-right: 5px;
        margin-top: 5px;
        margin-bottom: 5px;
    }
`;